import { Component, OnInit } from '@angular/core';
import Configs from '@shared/constants/configs';
import { Constants } from '@shared/constants/constants';
import { environment } from '@env/environment';
import { PagedResponse } from '@shared/models/paged-response';
import { FormControl } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Company } from '@shared/enums/company';
import { SpinnerService } from '@shared/services/spinner.service';
import { AuthService } from '@core/auth/auth.service';
import { ApiService } from '@shared/apis';
import { FileService } from '@shared/services/file.service';
import Roles from '@shared/constants/roles';
import Role from '@shared/constants/role';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { PageEvent } from '@shared/models/page-event';
import Utils from '@shared/utils/utils';
import { Options } from '@shared/models/options';
import { FileUploadComponent } from '@routes/dialogs/file-upload/file-upload.component';
import { ZipCode } from '@shared/models/zip-code';
import { ZipCodeEditComponent } from '@routes/b2b/zip-code-list/zip-code-edit/zip-code-edit.component';
import { MasterCode } from '@shared/enums/master-code';

@Component({
  selector: 'app-zip-code',
  templateUrl: './zip-code.component.html',
  styleUrls: ['./zip-code.component.scss']
})
export class ZipCodeComponent implements OnInit {

  readonly configs = Configs;
  readonly color = Configs.badgeColor;
  readonly constants = Constants;
  readonly backend = environment.api.backend;
  realPage: number;

  isAdmin = false;
  isAdminOnly = false;

  showDetail: boolean;
  pagedResponse: PagedResponse;

  query: any = {};
  q: any = {};
  searchText = new FormControl(null);
  partnerSelect = new FormControl(null);

  zipCodeData!: ZipCode[];
  selectedData!: ZipCode;
  companyCodes: any[] = [];
  partnerOptions;


  bsModalRef: BsModalRef;
  isCreatable = false;

  isDealerSupervisor = false;
  isHq = false;
  isReadOnly = false;
  company;
  companies = Company;
  userType: string;

  constructor(
    private modalService: BsModalService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private apiService: ApiService,
    private fileService: FileService,
  ) {
    this.isAdmin = this.authService.hasType(Roles.b2bAdmin);
    // this.isReadOnly = this.authService.hasType(Roles.b2bPartnerAdmin);
    this.isHq = this.authService.isHq();
    this.isDealerSupervisor = this.authService.hasRoleInCompany(Role.secaDealerSuperVisor);
    this.company = this.authService.getCurrentCompany();
  }

  ngOnInit(): void {
    this.userType = this.authService.getUserType();

    this.getOrganizationName();
    this.showList();

    this.isCreatable = ([Company.SeaIm, Company.Seca].includes(this.company) && this.isDealerSupervisor) || this.isAdmin;
    this.searchText.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(text => {
        this.q = text?.trim();
        this.showList();
      });
    this.apiService.master.getConstant(MasterCode.B2bZipcodePartners).subscribe(res => {
      let arr = [];
      Object.keys(res).map(function (key) {
        arr.push({ ['code']: res[key], ['name']: res[key] })
        return arr;
      });
      this.partnerOptions = arr;
    });
  }


  getOrganizationName() {
    this.companyCodes = this.authService.getCompanyCodes();
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    if (this.userType === Role.b2bCustomerAdmin) {
      this.query['userType'] = Role.b2bCustomer;
    }

    this.spinnerService.start();
    this.apiService.zipCode.getZipCodes(pageEvent, this.q, this.query)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.pagedResponse = res;
        this.zipCodeData = res.docs.map((m) => {
          return m;
        });
      }, err => Utils.showError(err));
  }

  modalOpen() {
    const initialState = {
      title: 'Zip Code Create', saveButtonLabel: 'Create',
    };

    this.bsModalRef = this.modalService.show(ZipCodeEditComponent, {
      initialState,
      class: 'modal-lg',
      ignoreBackdropClick: true
    });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.showList();
        this.showDetailInfo(result);
      }
    });
  }

  importModalOpen() {
    const config: any = {
      initialState: {
        templateId: 'uploadZipCodeData',
        title: 'Upload Zip Code Data',
        message: 'Please make it sure the uploading file is neither encrypted nor password locked.'
      },
      class: 'modal-file-upload modal-lg',
    };

    this.bsModalRef = this.modalService.show(FileUploadComponent, config);
    this.bsModalRef.content.onClose.subscribe(updated => {
      this.spinnerService.start();
      setTimeout(() => {
        this.showList();
        this.spinnerService.stop();
      }, 100);
    });
  }

  selectRow(zipCode) {
    // if (zipCode === this.selectedData) {
    //   return;
    // }

    this.showDetailInfo(zipCode);
  }

  showDetailInfo(zipCode) {
    const { zipcode } = zipCode;

    this.spinnerService.start();
    this.apiService.zipCode.getZipCode(zipcode)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.selectedData = res;
        this.showDetail = true;
      }, err => Utils.showError(err));
  }

  reload(data) {
    this.showList();
    if (data) {
      this.showDetailInfo(this.selectedData);
    }
  };

  options() {
    const opt: Options = {
      q: this.q,
      query: this.query,
    };
    return opt;
  }

  changeSelect(e) {
    if (e && e.code) {
      this.query = { partner: e.code };
    } else {
      delete this.query;
    }
    this.showList();
  }

}
